import { AccessTokenWarningState } from '@redux/reducers/accessTokenWarning/types';
import { AppState } from '@redux/types';

export function _getAccessTokenWarning(
  state: AppState
): AccessTokenWarningState {
  return state.accessTokenWarning;
}
